var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        class: [
          "bottom-chat-button text-center fw-500 fs-12 px-6 py-4 cyan",
          _vm.chatWindowOpen ? "d-none" : "d-none d-lg-block",
        ],
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.openChatWindow.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "d-flex align-center white--text" }, [
          _c("img", {
            attrs: {
              src: _vm.static_asset("/assets/img/chat.svg"),
              height: "30",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "fs-14 fw-700 ms-2" }, [
            _vm._v(_vm._s(_vm.$t("talk_with_us"))),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "las la-angle-up ms-auto" }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "white bottom-chat-window",
          _vm.chatWindowOpen ? "d-block h-auto" : "d-none h-60px",
        ],
      },
      [
        _c("div", { staticClass: "d-flex grey pa-3 align-center lighten-3" }, [
          _c("img", {
            staticClass: "size-30px",
            attrs: { src: _vm.generalSettings.chat.customer_chat_logo },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "mx-3 fs-14 fw-700" }, [
            _vm._v(_vm._s(_vm.generalSettings.chat.customer_chat_name)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ms-auto",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.closeChatWindow.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "la la-close fs-20" })]
          ),
        ]),
        _vm._v(" "),
        _vm.isAuthenticated
          ? _c(
              "div",
              { staticClass: "overflower chat-box d-flex flex-column pa-4" },
              [
                _c(
                  "ul",
                  {
                    ref: "chatList",
                    staticClass:
                      "list-unstyled mt-auto px-0 d-flex flex-column",
                  },
                  _vm._l(_vm.messages, function (message, i) {
                    return _c("li", { key: i, staticClass: "mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "fs-10 opacity-60 text-center" },
                        [_vm._v(_vm._s(message.time))]
                      ),
                      _vm._v(" "),
                      message.user_id == _vm.currentUser.id
                        ? _c(
                            "div",
                            { staticClass: "d-flex text-end ps-8 own" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-grow-1 message fs-13" },
                                [_vm._v(_vm._s(message.message))]
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "d-flex pe-8" },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "me-2",
                                  attrs: { size: "36px" },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      alt: "Avatar",
                                      src: _vm.generalSettings.chat
                                        .customer_chat_logo,
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex-grow-1 message fs-13" },
                                [_vm._v(_vm._s(message.message))]
                              ),
                            ],
                            1
                          ),
                    ])
                  }),
                  0
                ),
              ]
            )
          : _c("div", { staticClass: "text-center px-5 py-7 chat-box" }, [
              _c("img", {
                attrs: { src: _vm.static_asset("/assets/img/chat-login.png") },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fw-500" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("you_have_to")) +
                      "\n                "
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "primary--text",
                      attrs: { to: { name: "Login" } },
                    },
                    [_vm._v(_vm._s(_vm.$t("login")))]
                  ),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("or")) +
                      "\n                "
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "primary--text",
                      attrs: { to: { name: "Registration" } },
                    },
                    [_vm._v(_vm._s(_vm.$t("register")))]
                  ),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("as_a_customer_to_contact_us")) +
                      "\n            "
                  ),
                ],
                1
              ),
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grey pa-4 lighten-3" },
          [
            _c(
              "v-form",
              {
                staticClass: "white rounded-pill",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.sendMessage()
                  },
                },
              },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "", align: "center" } },
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticClass: "border-0",
                          attrs: { outlined: "", flat: "", "hide-details": "" },
                          model: {
                            value: _vm.chat.message,
                            callback: function ($$v) {
                              _vm.$set(_vm.chat, "message", $$v)
                            },
                            expression: "chat.message",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "me-1",
                            attrs: {
                              type: "submit",
                              icon: "",
                              color: "dark",
                              disabled: _vm.sending,
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.sendMessage.apply(null, arguments)
                              },
                            },
                          },
                          [_c("i", { staticClass: "las la-paper-plane fs-20" })]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }